export const CARD_FINDER_OPEN_ACTION = {
  actionName: 'cardfinder_open',
  actionSection: 'ru_cardfinder_entry',
  actionType: 'open',
};
